// Premium haptic + audio feedback for key actions.
// Sound is synthesized with the Web Audio API (no asset needed) and can be muted
// via localStorage("dmd_sound" = "off"). Everything fails silently.

let _ctx = null;
function ctx() {
  if (typeof window === "undefined") return null;
  try {
    if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (_ctx.state === "suspended") _ctx.resume();
    return _ctx;
  } catch { return null; }
}

function soundOn() {
  try { return localStorage.getItem("dmd_sound") !== "off"; } catch { return true; }
}

function haptic(pattern) {
  try { if (navigator?.vibrate) navigator.vibrate(pattern); } catch {}
}

// Play a short tone (sine, soft attack/decay) at time offset t0.
function tone(freq, t0, dur = 0.14, gain = 0.06) {
  const ac = ctx();
  if (!ac) return;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

// Big success: analyse terminée / profil généré. Rising 3-note chime + double buzz.
export function celebrate() {
  haptic([18, 40, 28]);
  if (!soundOn()) return;
  const ac = ctx();
  if (!ac) return;
  const t = ac.currentTime;
  tone(587.33, t, 0.13);        // D5
  tone(783.99, t + 0.1, 0.14);  // G5
  tone(1046.5, t + 0.2, 0.22);  // C6
}

// Light success: action confirmée. Single soft note + short buzz.
export function success() {
  haptic([26]);
  if (!soundOn()) return;
  const ac = ctx();
  if (!ac) return;
  tone(880, ac.currentTime, 0.12, 0.05);
}

// Simple tactile tap (no sound) — for navigation / buttons.
export function tap() {
  haptic([16]);
}

export function isSoundOn() { return soundOn(); }
export function toggleSound() {
  const on = soundOn();
  try { localStorage.setItem("dmd_sound", on ? "off" : "on"); } catch {}
  if (!on) success();
  return !on;
}
